/**
 * Configuracion MSAL para Azure AD del cliente.
 * Auth automatica con cuenta corporativa via SSO.
 * En el piloto inicial: tenant Tecpetrol.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    // Reemplazar con valores reales de la app registration en Azure AD
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID ?? "",
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID ?? "common"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // mejor que localStorage para seguridad
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console -- diagnóstico MSAL, sólo en desarrollo
          console.log(`[MSAL ${LogLevel[level]}]`, message);
        }
      },
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes que se solicitan al login.
 *
 * - `User.Read`: leer perfil propio (nombre, correo) — base de la sesión.
 * - `Sites.Read.All` / `Sites.ReadWrite.All`: acceder a las listas del sitio
 *   SharePoint donde vive el backend del PMIS.
 * - `Mail.Send`: enviar correos vía Microsoft Graph desde el navegador del
 *   usuario que dispara la acción (handovers de tipo "accion"). Es delegated,
 *   por lo que el correo sale del buzón del propio usuario.
 */
export const loginRequest = {
  scopes: [
    "User.Read",
    "Sites.Read.All",
    "Sites.ReadWrite.All",
    "Mail.Send",
  ],
};

/** Scope para acceder a SharePoint del cliente (en piloto: Tecpetrol). */
export const sharepointRequest = {
  scopes: ["https://tecpetrol.sharepoint.com/.default"],
};

/**
 * Scope dedicado para enviar correos vía Graph. Lo pedimos puntualmente
 * antes de cada envío con `acquireTokenSilent`. Si el consent no se dio
 * en el login inicial, se eleva a `acquireTokenPopup` (un solo prompt
 * por usuario, después queda cacheado).
 */
export const graphMailRequest = {
  scopes: ["https://graph.microsoft.com/Mail.Send"],
};
